import { type ReactNode } from 'react';
import { type ExternalToast, toast } from 'sonner';

import { Toaster as ToasterPrimitive } from '@ui/components/base/sonner';

export enum ToastVariant {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

export const toastWithVariant = (variant: ToastVariant, message: ReactNode, options?: ExternalToast) =>
  toast[variant](message, options);

const MAX_VISIBLE_TOASTS = 10;

const Toaster = () => (
  <ToasterPrimitive position="bottom-center" richColors expand visibleToasts={MAX_VISIBLE_TOASTS} />
);

export { Toaster, toast };
